export default __webpack_public_path__ + "af4fdf63c0584fc31888b183213176c7.png";